module.exports = __webpack_public_path__ + "static/opengraph-a83e750b35fa221a8a41713749946e41.jpg";